<template>
  <div
    class="search"
    @click="hollowClick"
  >
    <BespokeInput
      class="search__input"

      :value="query"
      @input="hollow ? 0 : doSearch($event)"

      :iconClick="iconClick"
      :icon="require( query || focused ? '@/assets/global-icons/cross-white-circle.svg' : '@/assets/search-icons/search.svg' )"

      @focus="hollow ? 0 : focused = true"
      @blur="handleBlur"
    >
      <span class="text-italic" v-if="isLobby"><b style="margin-right: 1.5px">Search</b> <span class="text-mid-grey">{{placeholder}}</span></span>
      <span class="text-italic" v-else><b style="margin-right: 1.5px">Search to invite to Room</b></span>
    </BespokeInput>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { promiseTime } from '@/functions/utility.js';
import BespokeInput from '@/components/global/inputs/BespokeInput.vue';

export default {
  name: 'SearchBar',
  components: { BespokeInput },
  props: {
    hollow: Boolean
  },
  data: () => ({
    focused: false
  }),
  computed: {
    ...mapGetters('search', ['query', 'placeholder']),
    ...mapGetters('routing', ['isLobby']),
    ...mapGetters([
      'viewport/isMobile',
      'sidebar/panelId'
    ]),
    vm: vm => vm
  },
  methods: {
    ...mapActions('search', ['clear', 'doSearch']),
    ...mapActions([
      'sidebar/open',
      'sidebar/close',
      'sidebar/openPrev',
    ]),
    async hollowClick(e){
      if(!this.hollow) return;

      e.preventDefault()
      this['sidebar/open']('search');

      // We open the search sidebar panel and wait 125ms for it to finish animating in before focusing the element
      // This is because safari will push the page up if the input is in the lower half of the screen at the point of focus.
      setTimeout(() => {
          document.querySelector('.sidebar-content__panel input')?.focus();
      }, 125)
    },
    iconClick(){
      if(this.hollow) return;
      if(this.query || this.focused) {
        this.clear();
        this['sidebar/openPrev']();
      }
    },
    async handleBlur(){
      if(this.hollow || this.query) return;
      // previously I had no timeout and no if below, but that created problems when you "closed" the search by clicking on a sidebar item
      // specifically, if you went to the previous sidebar item you were on, the sidebar would just close
      // because the click closes the sidebar if you click on the thing that's currently open
      // if you clicked on a different thing, then it'd flicker the previous panel before going to the next
      // solution: wait until after the click would have fired, then if the search is still visible, openPrev
      await promiseTime(100);
      if(this['sidebar/panelId'] === 'search') this['sidebar/openPrev']();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.search {
  padding: 10px;

  &__input {
    height: 60px;
    background-color: $grey-7;
    width: 100%;
    padding: 19px 25px 19px 15px;
    box-sizing: border-box;
    color: white;
    font-size: 18px;
    border-radius: 17px;
  }
}
</style>
